<ui-section class="h-full w-full p-6" title="Title Search" type="page">
	<div title-action>
		<ui-button
			label="Search New PIN"
			(click)="openTitleSearchDrawer()"
			preset="MEDIUM_EMPHASIS"
			icon="search"
			teranetLoginGuard
		>
		</ui-button>
	</div>
	<div section-content class="flex flex-1 justify-between">
		<div>
			<div class="flex flex-1">
				<app-anchor
					*ngFor="let page of pages; let i = index"
					type="tab"
					[url]="page.page"
					[testHook]="testHooks.Link"
					>{{ page.text }}</app-anchor
				>
			</div>
		</div>

		<div class="flex gap-2 items-center">
			<ui-button
				data-intercom-target="sync-view-docket-summary"
				*ngIf="(writs && writs?.length > 0) || primary"
				icon="file"
				(click)="showDocketSummary()"
				teranetLoginGuard
				label="View Docket"
				[testHook]="testHooks.Button"
			/>
			<app-teranet-balance></app-teranet-balance>
		</div>
	</div>
</ui-section>

<div class="p-5 pt-0 overflow-y-auto">
	<router-outlet class="hidden-router"></router-outlet>
</div>
